import { useEffect, useState } from "react";

/** settings-fx-layout (owner 2026-09-30): the history flows in the PAGE
 *  scroll -- no nested vertical scroller, no fixed height -- and the header is
 *  sticky against the page. A horizontal scroller would capture that sticky
 *  header, so the table only becomes a sideways scroller when its columns do
 *  not fit (a phone, or a narrow column beside the detail panel). */
export function useNeedsSideways(minWidth: number) {
  // A CALLBACK ref, so a table that mounts after a loading state is still
  // observed (a plain ref read once in an effect missed it -- found by the
  // staging browser tests on the Duty Rates tab, 2026-09-30).
  const [el, setEl] = useState<HTMLDivElement | null>(null);
  const [needs, setNeeds] = useState(false);
  useEffect(() => {
    if (!el) return undefined;
    const measure = () => setNeeds(el.clientWidth > 0 && el.clientWidth < minWidth);
    measure();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => window.removeEventListener("resize", measure);
    }
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [el, minWidth]);
  return [setEl, needs] as const;
}
